import BaseSidebar from './base-sidebar';

export default BaseSidebar;